/**
 * Generated by orval v8.11.0 🍺
 * Do not edit manually.
 * Core API
 * Core API Documentation
 * OpenAPI spec version: 1.0
 */
import { useMutation, useQuery } from "@tanstack/react-query";
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  MutationFunction,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseMutationOptions,
  UseMutationResult,
  UseQueryOptions,
  UseQueryResult,
} from "@tanstack/react-query";

import type {
  AddMemberCommandControllerAddMember201,
  AddMemberDto,
  ListMembersQueryControllerListMembersParams,
  ListMembersResponseDto,
} from "../model";

import { axiosClient } from "../../lib/api";

type AwaitedInput<T> = PromiseLike<T> | T;

type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;

/**
 * @summary Add a member to an organisation
 */
export const addMemberCommandControllerAddMember = (
  organisationSlug: string,
  addMemberDto: AddMemberDto,
  signal?: AbortSignal,
) => {
  return axiosClient<AddMemberCommandControllerAddMember201>({
    url: `/v1/organisations/${organisationSlug}/membership`,
    method: "POST",
    headers: { "Content-Type": "application/json" },
    data: addMemberDto,
    signal,
  });
};

export const getAddMemberCommandControllerAddMemberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof addMemberCommandControllerAddMember>>,
    TError,
    { organisationSlug: string; data: AddMemberDto },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof addMemberCommandControllerAddMember>>,
  TError,
  { organisationSlug: string; data: AddMemberDto },
  TContext
> => {
  const mutationKey = ["addMemberCommandControllerAddMember"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof addMemberCommandControllerAddMember>>,
    { organisationSlug: string; data: AddMemberDto }
  > = (props) => {
    const { organisationSlug, data } = props ?? {};

    return addMemberCommandControllerAddMember(organisationSlug, data);
  };

  return { mutationFn, ...mutationOptions };
};

export type AddMemberCommandControllerAddMemberMutationResult = NonNullable<
  Awaited<ReturnType<typeof addMemberCommandControllerAddMember>>
>;
export type AddMemberCommandControllerAddMemberMutationBody = AddMemberDto;
export type AddMemberCommandControllerAddMemberMutationError = void;

/**
 * @summary Add a member to an organisation
 */
export const useAddMemberCommandControllerAddMember = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof addMemberCommandControllerAddMember>>,
      TError,
      { organisationSlug: string; data: AddMemberDto },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof addMemberCommandControllerAddMember>>,
  TError,
  { organisationSlug: string; data: AddMemberDto },
  TContext
> => {
  return useMutation(
    getAddMemberCommandControllerAddMemberMutationOptions(options),
    queryClient,
  );
};
/**
 * Returns a paginated list of organisation members
 * @summary List members of an organisation
 */
export const listMembersQueryControllerListMembers = (
  organisationSlug: string,
  params?: ListMembersQueryControllerListMembersParams,
  signal?: AbortSignal,
) => {
  return axiosClient<ListMembersResponseDto>({
    url: `/v1/organisations/${organisationSlug}/membership`,
    method: "GET",
    params,
    signal,
  });
};

export const getListMembersQueryControllerListMembersQueryKey = (
  organisationSlug: string,
  params?: ListMembersQueryControllerListMembersParams,
) => {
  return [
    `/v1/organisations/${organisationSlug}/membership`,
    ...(params ? [params] : []),
  ] as const;
};

export const getListMembersQueryControllerListMembersQueryOptions = <
  TData = Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
  TError = void,
>(
  organisationSlug: string,
  params?: ListMembersQueryControllerListMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
        TError,
        TData
      >
    >;
  },
) => {
  const { query: queryOptions } = options ?? {};

  const queryKey =
    queryOptions?.queryKey ??
    getListMembersQueryControllerListMembersQueryKey(organisationSlug, params);

  const queryFn: QueryFunction<
    Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>
  > = ({ signal }) =>
    listMembersQueryControllerListMembers(organisationSlug, params, signal);

  return {
    queryKey,
    queryFn,
    enabled: organisationSlug !== null && organisationSlug !== undefined,
    ...queryOptions,
  } as UseQueryOptions<
    Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
    TError,
    TData
  > & { queryKey: DataTag<QueryKey, TData, TError> };
};

export type ListMembersQueryControllerListMembersQueryResult = NonNullable<
  Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>
>;
export type ListMembersQueryControllerListMembersQueryError = void;

export function useListMembersQueryControllerListMembers<
  TData = Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
  TError = void,
>(
  organisationSlug: string,
  params: undefined | ListMembersQueryControllerListMembersParams,
  options: {
    query: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): DefinedUseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMembersQueryControllerListMembers<
  TData = Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
  TError = void,
>(
  organisationSlug: string,
  params?: ListMembersQueryControllerListMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
        TError,
        TData
      >
    > &
      Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
          TError,
          Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>
        >,
        "initialData"
      >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
export function useListMembersQueryControllerListMembers<
  TData = Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
  TError = void,
>(
  organisationSlug: string,
  params?: ListMembersQueryControllerListMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
};
/**
 * @summary List members of an organisation
 */

export function useListMembersQueryControllerListMembers<
  TData = Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
  TError = void,
>(
  organisationSlug: string,
  params?: ListMembersQueryControllerListMembersParams,
  options?: {
    query?: Partial<
      UseQueryOptions<
        Awaited<ReturnType<typeof listMembersQueryControllerListMembers>>,
        TError,
        TData
      >
    >;
  },
  queryClient?: QueryClient,
): UseQueryResult<TData, TError> & {
  queryKey: DataTag<QueryKey, TData, TError>;
} {
  const queryOptions = getListMembersQueryControllerListMembersQueryOptions(
    organisationSlug,
    params,
    options,
  );

  const query = useQuery(queryOptions, queryClient) as UseQueryResult<
    TData,
    TError
  > & { queryKey: DataTag<QueryKey, TData, TError> };

  return { ...query, queryKey: queryOptions.queryKey };
}

/**
 * @summary Remove a member from an organisation
 */
export const removeMemberCommandControllerRemoveMember = (
  organisationSlug: string,
  userId: string,
  signal?: AbortSignal,
) => {
  return axiosClient<void>({
    url: `/v1/organisations/${organisationSlug}/membership/${userId}`,
    method: "DELETE",
    signal,
  });
};

export const getRemoveMemberCommandControllerRemoveMemberMutationOptions = <
  TError = void,
  TContext = unknown,
>(options?: {
  mutation?: UseMutationOptions<
    Awaited<ReturnType<typeof removeMemberCommandControllerRemoveMember>>,
    TError,
    { organisationSlug: string; userId: string },
    TContext
  >;
}): UseMutationOptions<
  Awaited<ReturnType<typeof removeMemberCommandControllerRemoveMember>>,
  TError,
  { organisationSlug: string; userId: string },
  TContext
> => {
  const mutationKey = ["removeMemberCommandControllerRemoveMember"];
  const { mutation: mutationOptions } = options
    ? options.mutation &&
      "mutationKey" in options.mutation &&
      options.mutation.mutationKey
      ? options
      : { ...options, mutation: { ...options.mutation, mutationKey } }
    : { mutation: { mutationKey } };

  const mutationFn: MutationFunction<
    Awaited<ReturnType<typeof removeMemberCommandControllerRemoveMember>>,
    { organisationSlug: string; userId: string }
  > = (props) => {
    const { organisationSlug, userId } = props ?? {};

    return removeMemberCommandControllerRemoveMember(organisationSlug, userId);
  };

  return { mutationFn, ...mutationOptions };
};

export type RemoveMemberCommandControllerRemoveMemberMutationResult =
  NonNullable<
    Awaited<ReturnType<typeof removeMemberCommandControllerRemoveMember>>
  >;

export type RemoveMemberCommandControllerRemoveMemberMutationError = void;

/**
 * @summary Remove a member from an organisation
 */
export const useRemoveMemberCommandControllerRemoveMember = <
  TError = void,
  TContext = unknown,
>(
  options?: {
    mutation?: UseMutationOptions<
      Awaited<ReturnType<typeof removeMemberCommandControllerRemoveMember>>,
      TError,
      { organisationSlug: string; userId: string },
      TContext
    >;
  },
  queryClient?: QueryClient,
): UseMutationResult<
  Awaited<ReturnType<typeof removeMemberCommandControllerRemoveMember>>,
  TError,
  { organisationSlug: string; userId: string },
  TContext
> => {
  return useMutation(
    getRemoveMemberCommandControllerRemoveMemberMutationOptions(options),
    queryClient,
  );
};
